const CARDS = [
  {
    id: 1,
    title: '暗影猎手',
    tag: '热血',
    rating: '9.6',
    desc: '在这个被暗影笼罩的世界，少年猎手踏上复仇之路，以凡人之躯对抗远古邪神。热血与羁绊交织的史诗篇章。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%2C%20young%20male%20warrior%20with%20dark%20hair%20and%20glowing%20sword%2C%20dramatic%20orange%20and%20black%20color%20scheme%2C%20shounen%20manga%20art%20style%2C%20dynamic%20action%20pose%2C%20clean%20character%20design%2C%20professional%20manga%20illustration%20quality%2C%20simple%20dark%20background&width=400&height=560&seq=card-01-shadow-hunter&orientation=portrait',
    chapters: '238话',
    status: '连载中',
  },
  {
    id: 2,
    title: '恋爱方程式',
    tag: '恋爱',
    rating: '9.3',
    desc: '高冷学霸遇上元气少女，一场始于数学补习的甜蜜恋爱。从互不顺眼到怦然心动，青春就该这样美好。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20shoujo%20manga%20cover%20style%2C%20high%20school%20couple%20in%20uniform%20with%20blushing%20expressions%2C%20soft%20pink%20and%20peach%20color%20scheme%2C%20romantic%20manga%20art%20style%2C%20cherry%20blossom%20petals%20floating%2C%20sweet%20and%20pure%20atmosphere%2C%20simple%20light%20background&width=400&height=560&seq=card-02-love-formula&orientation=portrait',
    chapters: '120话',
    status: '已完结',
  },
  {
    id: 3,
    title: '星辰变·外传',
    tag: '奇幻',
    rating: '9.5',
    desc: '星辰大陆风云再起，少年剑修逆天改命，在万族争锋的时代中书写属于自己的传奇。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%20style%2C%20cultivator%20with%20flowing%20robes%20and%20sword%20standing%20on%20clouds%2C%20gold%20and%20teal%20color%20scheme%2C%20elegant%20Chinese%20ink%20painting%20style%2C%20mystical%20energy%20effects%2C%20celestial%20atmosphere%2C%20simple%20ethereal%20background&width=400&height=560&seq=card-03-star-change&orientation=portrait',
    chapters: '12话',
    status: '连载中',
  },
  {
    id: 4,
    title: '都市灵异录',
    tag: '悬疑',
    rating: '9.1',
    desc: '普通大学生意外获得阴阳眼，从此卷入都市灵异事件的漩涡。每一个案件背后都隐藏着不为人知的真相。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20seinen%20manga%20cover%20style%2C%20college%20student%20with%20supernatural%20ability%20in%20dark%20alley%2C%20indigo%20and%20amber%20color%20scheme%2C%20mystery%20horror%20manga%20art%20style%2C%20eerie%20atmosphere%20with%20ghostly%20figures%2C%20urban%20night%20setting%2C%20simple%20dark%20background&width=400&height=560&seq=card-04-urban-ghost&orientation=portrait',
    chapters: '156话',
    status: '连载中',
  },
  {
    id: 5,
    title: '机甲战神',
    tag: '科幻',
    rating: '9.4',
    desc: '在机甲横行的未来世界，少年驾驶员与他的机甲伙伴并肩作战，守护人类最后的希望。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20mecha%20anime%20cover%20style%2C%20giant%20robot%20with%20pilot%20in%20cockpit%2C%20silver%20and%20coral%20red%20color%20scheme%2C%20sci-fi%20manga%20art%20style%2C%20futuristic%20mechanical%20design%2C%20explosive%20action%20background%2C%20clean%20modern%20aesthetic%2C%20simple%20tech%20background&width=400&height=560&seq=card-05-mecha-god&orientation=portrait',
    chapters: '198话',
    status: '连载中',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑精选高分漫画，品质保证，每一部都值得阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex">
                <div className="w-28 sm:w-32 flex-shrink-0 h-40 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-between min-w-0">
                  <div>
                    <div className="flex items-center gap-2 mb-1.5">
                      <h3 className="text-sm font-heading font-bold text-foreground-900 truncate">{item.title}</h3>
                      <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] rounded-full bg-accent-100 text-accent-700 font-medium">
                        {item.tag}
                      </span>
                    </div>
                    <div className="flex items-center gap-1 mb-2">
                      <i className="ri-star-fill text-amber-400 text-xs"></i>
                      <span className="text-xs font-semibold text-foreground-700">{item.rating}</span>
                    </div>
                    <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                    <span>{item.chapters}</span>
                    <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-medium ${
                      item.status === '连载中' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                    }`}>{item.status}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {CARDS.slice(3).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all duration-300 flex flex-col sm:flex-row"
            >
              <div className="sm:w-36 flex-shrink-0 h-44 sm:h-auto overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-4 flex flex-col justify-between min-w-0">
                <div>
                  <div className="flex items-center gap-2 mb-1.5">
                    <h3 className="text-sm font-heading font-bold text-foreground-900">{item.title}</h3>
                    <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] rounded-full bg-accent-100 text-accent-700 font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 mb-2">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    <span className="text-xs font-semibold text-foreground-700">{item.rating}</span>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                  <span>{item.chapters}</span>
                  <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-medium ${
                    item.status === '连载中' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                  }`}>{item.status}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}